import axios from "axios";
import ReceiptCheckDTO from "@/models/ReceiptCheckDTO";
import TraderDealDTO from "@/models/TraderDealDTO";

export const traderDeals = {
    requestVideo: async (dealId: string): Promise<TraderDealDTO> => {
        const resp = await axios({
            url: `/trader-deals/${dealId}/video-request`,
            method: 'POST',
        });

        return resp.data as TraderDealDTO;
    },
    changeAmount: async (dealId: string, amount: string): Promise<TraderDealDTO> => {
        const resp = await axios({
            url: `/trader-deals/${dealId}/amount`,
            method: 'PUT',
            data: {amount},
        });

        return resp.data as TraderDealDTO;
    },
    receiptCheck: async (dealId: string, attachmentId: number): Promise<ReceiptCheckDTO> => {
        const resp = await axios({
            url: `/trader-deals/${dealId}/receipt-check`,
            method: 'POST',
            data: {attachmentId},
        });

        return resp.data as ReceiptCheckDTO;
    },
}
